<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="['mobile', 'tablet'] | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selection"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>

    <div *ngIf="['laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="selection"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
    </div>
</tt-page>

<ng-template #selection>
    <ng-container *ngIf="!!setting">
        <tt-select ttLabel="labour" [(ttModel)]="setting.labour_no" (ttModelChange)="onChanged($event, 'labour_no')" [ttData]="selectListLabours" ttDataId="item_id" ttDataName="item_name"></tt-select>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto [ttText]="'create_new_offdutydata'" (ttClick)="goToFunc('p2offdutydata')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!setting">
        <tt-list [ttData]="itemsListOffDutyDatas"></tt-list>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-select class="col-xs-12 sp-0" tt-label="labour" tt-model="vm.model.setting.labour_no" tt-change="vm.onChanged($value, 'labour_no')" tt-data="vm.model.selectListLabours" tt-data-id="item_id" tt-data-name="item_name"></tt-select>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListOffDutyDatas" badge="" ltype="" design-var="s12t0"></im-list-directive>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="create_new_offdutydata" tt-click="vm.goToFunc('p2offdutydata')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>
</tt-page>-->
